import {CardBindingType} from '@yandex-delivery/api/model/payment'
import {Modal, useAddNotification, useReachGoalEffect} from '@yandex-delivery/blocks'
import type {PropsWithClasses} from '@yandex-delivery/blocks/theme/UNSTABLE_makeStyles'
import {
  type FrameMessageAbort,
  type FrameMessageError,
  type FrameMessageSuccessHandler,
  useCardBoundRef,
} from '@yandex-delivery/hooks'
import React from 'react'

import {useConfigContext} from './ConfigProvider'
import {ClassKey, useClasses} from './TrustFrame.classes'

export type Props = PropsWithClasses<ClassKey> & {
  onClose?(): void
  onSuccess?: FrameMessageSuccessHandler
  bindingUrl: string
  bindingType: CardBindingType
  isMobile?: boolean
}

export function TrustFrame(props: Props): React.ReactElement<Props> {
  const {onClose, onSuccess, bindingUrl, bindingType, isMobile, classes: classesProp} = props
  const {lang, currency} = useConfigContext()
  const classes = useClasses(classesProp)
  const addNotification = useAddNotification()

  function errorHandler(m: FrameMessageError) {
    onClose?.()
    addNotification(m.reason, {type: 'error'})
  }
  function abortHandler(_: FrameMessageAbort) {
    onClose?.()
  }

  const ref = useCardBoundRef<HTMLDivElement>(bindingUrl, {
    preserveQueryParams: bindingType === CardBindingType.Psp,
    currency,
    lang,
    device: isMobile ? 'mobile' : 'desktop',
    className: classes.iframe,
    onSuccess,
    onError: errorHandler,
    onAbort: abortHandler,
  })

  useReachGoalEffect('page-watch-addcard')

  return <Modal.Body ref={ref} className={classes.modal} />
}
